import React from "react";
export const ToggleSwitch = ({ isOn, onClick, color }) => (
    <div
      className={`toggle-switch ${isOn ? "on" : "off"}`}
      title={`${isOn?"revoke permission":"grant permission"}`}
      onClick={onClick}
      style={{
        width: "50px",
        height: "25px",
        backgroundColor: isOn ? color : "#ccc",
        borderRadius: "15px",
        cursor: "pointer",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: "#fff",
          borderRadius: "50%",
          position: "absolute",
          top: "50%",
          left: isOn ? "25px" : "5px",
          transform: "translateY(-50%)",
          transition: "left 0.3s ease",
        }}
      />
    </div>
  );